import React, { useCallback } from "react";
import type { Client } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";
import { useAuth } from "../../auth/AuthContext";

export const ClientsPage: React.FC = () => {
  const { client } = useAuth();

  const fetchEntities = useCallback(
    async (query: string) => {
      const response = await client.get(
        `/modules/entities?q=${encodeURIComponent(query)}&take=10&skip=0`
      );
      if (!response.ok) {
        return [];
      }
      const payload = (await response.json()) as { data: Array<{ id: number; name: string; document?: string | null }> };
      return payload.data.map((item) => ({
        id: item.id,
        label: `${item.name}${item.document ? ` (${item.document})` : ""}`,
      }));
    },
    [client]
  );

  return (
    <CrudPage<Client>
      title="Clientes"
      endpoint="/modules/clients"
      searchPlaceholder="Buscar por nome, documento..."
      columns={[
        { label: "Cliente", render: (item) => item.entity.name },
        { label: "Documento", render: (item) => item.entity.document ?? "-" },
        { label: "Ativo", render: (item) => (item.isActive ? "Sim" : "Nao") },
      ]}
      formFields={[
        {
          name: "entityRefId",
          label: "Entidade",
          type: "autocomplete",
          placeholder: "Digite para buscar entidade",
          fetchOptions: fetchEntities,
          getIdFromItem: (item) => item.entityId,
          getLabelFromItem: (item) => item.entity.name,
        },
        { name: "isActive", label: "Ativo", type: "checkbox" },
      ]}
      initialValues={{
        entityRefId: null,
        isActive: true,
      }}
      mapToPayload={(values) => ({
        entityId: Number(values.entityRefId),
        isActive: values.isActive,
      })}
      permissionWrite="CLIENT_WRITE"
    />
  );
};
